export const referralSettingsModel = (model) => {
    const item = model || {};

    return {
        logo: item.logo || '',
        logoSettings: item.logoSettings || {
            crop_mode: 0,
            gravity_mode: 0,
            quality: 90,
            quality_mode: 0,
        },
        referralBonus: item.referralBonus || 0,
        referredBonus: item.referredBonus || 0,
        enabled: item.enabled || 0,
        nameTranslations: item.nameTranslations || {},
    }
}
